<template>
  <div class="alert alert-danger" role="alert">
    <h4 class="alert-heading">{{ errorTitle }}</h4>
    <hr>
    <div v-if="!windowSizeAcceptable">
      <p>Es wurde eine Auflösung von {{ windowDimensions.width }} &times; {{ windowDimensions.height }} Pixel
        erkannt.</p>
      <p>Die Auflösung ist zu gering, um die EDiTh App brauchbar darzustellen.</p>
      <p>Die EDiTh App braucht eine Mindestgröße von {{ windowConstraints.minWidth }} &times;
        {{ windowConstraints.minHeight }} Pixel </p>
      <p>Bitte vergrößern Sie das Browserfenster oder nutzen Sie die Zoom-Funktion Ihres Browsers um herauszuzoomen.</p>
    </div>
    <div v-else>
      <!-- Should never happen -->
      <p>
        Es ist ein unklares Problem im Zusammenhang mit Fenstergröße aufgetreten
      </p>
    </div>
    <hr>
  </div>
</template>

<script>

export default {
  name: 'BrowserConstraintsInfoComponent',
  props: {
    windowSizeAcceptable: Boolean,
    windowDimensions: Object,
    windowConstraints: Object,
  },
  errorTitle() {
    if (!this.windowSizeAcceptable) {
      return "Unzureichende Fenstergröße!"
    } else {
      return "Unbekannter Fehler"
    }
  }
}
</script>
<style></style>